import React from 'react';
import { classNames, layoutClassNames, textClassNames } from './classNames';
import type { LayoutClassNameProps, TextClassNameProps } from './classNames';

export interface FormTextProps
  extends React.HTMLAttributes<HTMLElement>,
    LayoutClassNameProps,
    TextClassNameProps {
  as?: React.ElementType;
}

const FormText: React.FC<FormTextProps> = ({
  as: Component = 'div',
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textColor,
  textDecoration,
  textReset,
  ...props
}) => (
  <Component
    className={classNames(
      'form-text',
      textClassNames({
        textColor,
        textDecoration,
        textReset,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
);

export default FormText;
